import * as React from 'react';
import { cn } from '@se-platform/ui/utils';

// The four voices of a "way in" screen, from the F0 foundations board: a
// small-caps eyebrow, the thin Montserrat headline, the marketing-weight lede,
// and long-form fine print in Deep Navy. Everything else on a screen is a
// control or a label; nothing else gets to be a heading.

export function Eyebrow({
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { children: React.ReactNode }) {
  return (
    <span
      className={cn(
        'block font-display text-brand-eyebrow-lg uppercase text-brand-muted',
        className,
      )}
      {...props}
    />
  );
}

export function Headline({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement> & { children: React.ReactNode }) {
  return (
    <h1
      className={cn(
        'm-0 font-display text-brand-headline-sm text-brand-black sm:text-brand-headline',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  );
}

export function Lede({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement> & { children: React.ReactNode }) {
  return (
    <p
      className={cn('mt-5 max-w-[52ch] font-display text-brand-lede text-brand-muted', className)}
      {...props}
    />
  );
}

/** Fine print in Deep Navy: the brand's quiet alternative to black. */
export function FineNote({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement> & { children: React.ReactNode }) {
  return <p className={cn('text-brand-fine text-brand-navy', className)} {...props} />;
}

/** The small-caps heading that titles a field group or a derived-terms panel. */
export function GroupLabel({
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { children: React.ReactNode }) {
  return (
    <span
      className={cn('block font-display text-brand-eyebrow uppercase text-brand-muted', className)}
      {...props}
    />
  );
}
